import { useEffect, useState } from "react";
import { Api } from "../api/baseApi";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

const BlogDetails = () => {
  const { i18n } = useTranslation();
  const { slug } = useParams();

  const [blogData, setBlog] = useState(null);

  const stripHtml = (html) => {
    if (!html) return '';
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  };

  useEffect(() => {
    if (!slug) return;

    const fetchBlog = async () => {
      try {
        const res = await Api.get(`/api/${i18n.language}/blog/${slug}`);
        setBlog(res.data);
      } catch (error) {
        console.error("Failed to fetch blog:", error);
      }
    };

    fetchBlog();
  }, [i18n.language, slug]);

  const getImageUrl = (front_files) => {
    if (!front_files) return "";

    if (typeof front_files === "string") {
      return `${process.env.REACT_APP_PAGE_URL}${front_files.startsWith("/") ? front_files.slice(1) : front_files}`;
    }

    if (!Array.isArray(front_files) && front_files.file) {
      return `${process.env.REACT_APP_PAGE_URL}${front_files.file.startsWith("/") ? front_files.file.slice(1) : front_files.file}`;
    }

    if (Array.isArray(front_files) && front_files.length > 0) {
      const firstFile = front_files[0]?.file;
      return firstFile
        ? `${process.env.REACT_APP_PAGE_URL}${firstFile.startsWith("/") ? firstFile.slice(1) : firstFile}`
        : "";
    }

    return "";
  };

  return <>
    <Helmet>
      {blogData?.metaTags?.[0]?.translate?.title && (
        <title>{stripHtml(blogData.metaTags[0].translate.title)}</title>
      )}

      {blogData?.metaTags?.[0]?.translate?.description && (
        <meta
          name="description"
          content={stripHtml(blogData.metaTags[0].translate.description)}
        />
      )}

      {blogData?.metaTags?.[0]?.translate?.content && (
        <meta
          name="keywords"
          content={stripHtml(blogData.metaTags[0].translate.content)}
        />
      )}

      {blogData?.metaTags?.[0]?.translate?.title && (
        <meta property="og:title" content={stripHtml(blogData.metaTags[0].translate.title)} />
      )}

      {blogData?.metaTags?.[0]?.translate?.description && (
        <meta property="og:description" content={stripHtml(blogData.metaTags[0].translate.description)} />
      )}

      {blogData?.shereedLinks?.[0]?.canonical_link && (
          <link rel="canonical" href={blogData.shereedLinks[0].canonical_link}/>
      )}

      {blogData?.shereedLinks?.[0]?.shared_link && (
          <meta property="og:url" content={blogData.shereedLinks[0].shared_link}/>
      )}

      <meta property="og:type" content="article" />
    </Helmet>
    <section className="blog-details padding-y-120 position-relative overflow-hidden">
      <div className="container container-two">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="blog-details-top mb-64">
              <h1 className="blog-details-top__title mb-4 text-capitalize font-40">
                {blogData?.blog?.translate?.title && (
                  <span dangerouslySetInnerHTML={{ __html: blogData.blog.translate.title }} />
                )}
              </h1>
              <p className="blog-details-top__desc">
                {blogData?.blog?.translate?.description && (
                  <span dangerouslySetInnerHTML={{ __html: blogData.blog.translate.description }} />
                )}
              </p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="blog-details-content">
              {blogData?.blog?.front_files && (
                <div className="blog-details-content__thumb mb-32">
                  <img src={getImageUrl(blogData.blog.front_files)} alt="Blog main" />
                </div>
              )}

              {!!blogData?.blog?.features?.length &&
                blogData.blog.features.map((feature, index) => (
                  <div className="pt-30" key={index}>
                    <h4 className="blog-details-content__title mb-24">
                      {feature?.translate?.title && (
                        <span dangerouslySetInnerHTML={{ __html: feature.translate.title }} />
                      )}
                    </h4>
                    <p className="blog-details-content__desc mb-40">
                      {feature?.translate?.description && (
                        <span dangerouslySetInnerHTML={{ __html: feature.translate.description }} />
                      )}
                    </p>

                    <div className="row gy-4">
                      {!!feature?.front_files?.length &&
                        feature.front_files.map((item) => (
                          <div className="col-sm-3 col-3" key={item.id}>
                            <div className="blog-details-content__feature-thumb">
                              <img src={getImageUrl(item)} alt={feature?.translate?.title || "Feature"} />
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
};

export default BlogDetails;
